import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25395ff0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "roleCard" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-guanyuxitong" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.form,
      rules: _ctx.rules,
      "label-width": "135px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('role.form.code'),
          prop: "code"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              onInput: _cache[0] || (_cache[0] = e => _ctx.form.code = _ctx.valid(e)),
              modelValue: _ctx.form.code,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.code) = $event)),
              maxlength: "10",
              placeholder: _ctx.$t('role.form.code_placeholder'),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "placeholder", "disabled"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('role.form.name'),
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              onInput: _cache[2] || (_cache[2] = e => _ctx.form.name = _ctx.valid(e)),
              modelValue: _ctx.form.name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.name) = $event)),
              maxlength: "100",
              placeholder: _ctx.$t('role.form.name_placeholder'),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "placeholder", "disabled"])
          ]),
          _: 1
        }, 8, ["label"]),
        (_ctx.utils.Tools.getPropFromVuex('useDataLevel'))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: _ctx.$t('role.form.dataLevel'),
              prop: "dataLevel"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.dataLevel,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.dataLevel) = $event)),
                  disabled: _ctx.disabled
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _ctx.$t('role.personal'),
                      value: "0"
                    }, null, 8, ["label"]),
                    (_ctx.utils.Tools.getPropFromVuex('needDept'))
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          key: 0,
                          label: _ctx.$t('role.department'),
                          value: "1"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (_ctx.utils.Tools.getPropFromVuex('needDept'))
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          key: 1,
                          label: _ctx.$t('role.department_cascade'),
                          value: "2"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (_ctx.utils.Tools.getPropFromVuex('needCorp'))
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          key: 2,
                          label: _ctx.$t('role.organization'),
                          value: "3"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (_ctx.utils.Tools.getPropFromVuex('needCorp'))
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          key: 3,
                          label: _ctx.$t('role.organization_cascade'),
                          value: "4"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.flag)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: _ctx.$t('role.form.portalLevel'),
              prop: "portalLevel"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.portalLevel,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.portalLevel) = $event)),
                    disabled: _ctx.disabled
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: _ctx.$t('role.columns.VIEW'),
                        value: "0"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _ctx.$t('role.columns.EDIT'),
                        value: "1"
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: _ctx.$t('role.portalDataLevelDesc'),
                    placement: "top-start"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["content"])
                ])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('role.form.desc'),
          prop: "desc"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              onInput: _cache[6] || (_cache[6] = e => _ctx.form.desc = _ctx.valid(e)),
              modelValue: _ctx.form.desc,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.desc) = $event)),
              maxlength: "100",
              placeholder: "请输入说明",
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}